module.exports = __webpack_public_path__ + "img/lidl.cfe6f723.svg";